import { TrendingUp, TrendingDown } from "lucide-react";

let _sparkSeq = 0;

export function Sparkline({ points, color = "#0891B2", height = 36 }) {
  if (!Array.isArray(points) || points.length === 0) {
    return <div className="text-[10px] text-slate-400">no data</div>;
  }
  const values = points.map((p) => p.value ?? p.valuePercent ?? 0);
  const min = Math.min(...values);
  const max = Math.max(...values);
  const range = max - min || 1;
  const w = 200;
  const h = height;
  const step = points.length > 1 ? w / (points.length - 1) : w;
  const d = points.map((p, i) => {
    const v = p.value ?? p.valuePercent ?? 0;
    const x = i * step;
    const y = h - ((v - min) / range) * (h - 4) - 2;
    return `${i === 0 ? "M" : "L"} ${x.toFixed(1)} ${y.toFixed(1)}`;
  }).join(" ");
  const area = `${d} L ${w} ${h} L 0 ${h} Z`;
  const gradientId = `sparkfill-${++_sparkSeq}`;
  return (
    <svg viewBox={`0 0 ${w} ${h}`} preserveAspectRatio="none" className="w-full" style={{ height }} aria-hidden>
      <defs>
        <linearGradient id={gradientId} x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%"   stopColor={color} stopOpacity="0.35" />
          <stop offset="100%" stopColor={color} stopOpacity="0" />
        </linearGradient>
      </defs>
      <path d={area} fill={`url(#${gradientId})`} />
      <path d={d} fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

export function TrendChip({ value, suffix = "%", invertColors = false }) {
  if (value == null || isNaN(value)) return <span className="text-[10px] text-slate-400">—</span>;
  const up = value >= 0;
  const good = invertColors ? !up : up;
  const cls = good ? "text-emerald-600 bg-emerald-50" : "text-rose-600 bg-rose-50";
  const Icon = up ? TrendingUp : TrendingDown;
  return (
    <span className={`inline-flex items-center gap-1 text-[11px] font-semibold px-2 py-0.5 rounded-full ${cls}`} data-testid="trend-chip">
      <Icon className="w-3 h-3" />
      {Math.abs(value).toFixed(1)}{suffix}
    </span>
  );
}
